// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qqCx2jecTCAGZhfpexGF{flex-direction:column;width:100%;height:100%;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContentContainer": `qqCx2jecTCAGZhfpexGF`
};
export default ___CSS_LOADER_EXPORT___;
